import React from "react";
import { FormattedMessage } from "react-intl";
import { NavLink } from "react-router-dom";

const CallToAction = () => {
    return (
        <NavLink
            to={"/contact"}
            className="relative inline-flex items-center gap-3 bg-[#16A34A] text-white font-semibold text-sm uppercase tracking-[0.14em] rounded px-6 py-3.5 shadow-lg hover:bg-[#15803D] transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
        >
            <span><FormattedMessage id="call.to.action" /></span>
            <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-white"></span>
            </span>
        </NavLink>
    );
};

export default CallToAction;
